export default "__VITE_PUBLIC_ASSET__3964fe9f__"